var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visibility"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.3,
    d: "M16 8C10.9467 8 6.43999 10.84 4.23999 15.3333C6.43999 19.8267 10.9467 22.6667 16 22.6667C21.0533 22.6667 25.56 19.8267 27.76 15.3333C25.56 10.84 21.0533 8 16 8ZM16 21.3333C12.6933 21.3333 9.99999 18.64 9.99999 15.3333C9.99999 12.0267 12.6933 9.33333 16 9.33333C19.3067 9.33333 22 12.0267 22 15.3333C22 18.64 19.3067 21.3333 16 21.3333Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 5.33337C9.33337 5.33337 3.64004 9.48004 1.33337 15.3334C3.64004 21.1867 9.33337 25.3334 16 25.3334C22.6667 25.3334 28.36 21.1867 30.6667 15.3334C28.36 9.48004 22.6667 5.33337 16 5.33337ZM16 22.6667C10.9467 22.6667 6.44004 19.8267 4.24004 15.3334C6.44004 10.84 10.9467 8.00004 16 8.00004C21.0534 8.00004 25.56 10.84 27.76 15.3334C25.56 19.8267 21.0534 22.6667 16 22.6667ZM16 9.33337C12.6934 9.33337 10 12.0267 10 15.3334C10 18.64 12.6934 21.3334 16 21.3334C19.3067 21.3334 22 18.64 22 15.3334C22 12.0267 19.3067 9.33337 16 9.33337ZM16 18.6667C14.16 18.6667 12.6667 17.1734 12.6667 15.3334C12.6667 13.4934 14.16 12 16 12C17.84 12 19.3334 13.4934 19.3334 15.3334C19.3334 17.1734 17.84 18.6667 16 18.6667Z",
    fill: "#29ABE2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.e045f0a093b0687dbf42d11048683b13.svg";
export { ForwardRef as ReactComponent };